import React from "react";
import { useTheme } from "./ThemeProvider";

export type ThemeLogoVariant =
    | "dark"
    | "light"
    | "headerDark"
    | "headerLight"
    | "smallDark"
    | "smallLight";

interface ThemeLogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    variant?: ThemeLogoVariant;
}

export const ThemeLogo: React.FC<ThemeLogoProps> = ({ variant = "dark", alt, ...props }) => {
    const theme = useTheme();
    const source = {
        dark: theme.assets.logoDark,
        light: theme.assets.logoLight,
        headerDark: theme.assets.headerLogoDark,
        headerLight: theme.assets.headerLogoLight,
        smallDark: theme.assets.logoSmallDark,
        smallLight: theme.assets.logoSmallLight,
    }[variant];

    return <img src={source} alt={alt ?? theme.brand.companyName} {...props} />;
};
